import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

/**
 * <FileImage src="/api/files/{id}/download" ... /> — resolves to a blob URL via authenticated fetch.
 * Falls back to plain src (base64 dataURL / external http) untouched.
 */
export default function FileImage({ src, alt = "", className, style, testid }) {
  const [resolved, setResolved] = useState(null);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    if (!src) { setResolved(null); return; }
    // Data URL or plain http(s) (not our API)
    if (src.startsWith("data:") || (src.startsWith("http") && !src.includes("/api/files/"))) {
      setResolved(src);
      return;
    }
    // Our API — fetch as blob using authenticated axios (sends cookies)
    (async () => {
      try {
        const url = src.startsWith("/api") ? src.replace(/^\/api/, "") : src;
        const res = await api.get(url, { responseType: "blob" });
        if (cancelled) return;
        const ourl = URL.createObjectURL(res.data);
        objectUrlRef.current = ourl;
        setResolved(ourl);
      } catch (_) { if (!cancelled) setResolved(null); }
    })();
    return () => {
      cancelled = true;
      if (objectUrlRef.current) { URL.revokeObjectURL(objectUrlRef.current); objectUrlRef.current = null; }
    };
  }, [src]);

  if (!resolved) return null;
  return <img src={resolved} alt={alt} className={className} style={style} data-testid={testid} />;
}
